var definitions = [{
  id: 'Abs',
  type: 'formula',
  minparams: 1,
  maxparams: 1,
  callback: Math.abs
}, {
  id: 'Add',
  type: 'formula',
  minparams: 2,
  maxparams: 999,
  callback: function callback() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.reduce(function (memo, num) {
      return memo + parseFloat(num);
    }, 0);
  }
}, {
  id: 'And',
  type: 'formula',
  minparams: 2,
  maxparams: 999,
  callback: function callback() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return args.reduce(function (memo, num) {
      return memo && !!num;
    }, true);
  }
}, {
  id: 'Average',
  type: 'formula',
  minparams: 2,
  maxparams: 999,
  callback: function callback() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return definitions[1].callback.apply(null, args) / arguments.length;
  }
}, {
  id: 'Ceiling',
  type: 'formula',
  minparams: 1,
  maxparams: 1,
  callback: Math.ceil
}, {
  id: 'Concatenate',
  type: 'formula',
  minparams: 2,
  maxparams: 999,
  callback: function callback() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return args.reduce(function (memo, num) {
      return memo + num;
    }, '');
  }
}, {
  id: 'Contains',
  type: 'formula',
  minparams: 3,
  maxparams: 3,
  sticky: ['Text', 'String', 'Position (optional)'],
  callback: function callback(text, find, pos) {
    pos || (pos = 0);
    return text.indexOf(find, pos) !== -1;
  }
}, {
  id: 'DecodeBase64',
  type: 'formula',
  minparams: 1,
  maxparams: 1,
  callback: atob
}, {
  id: 'Divide',
  type: 'formula',
  minparams: 2,
  maxparams: 9999,
  callback: function callback() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return args.reduce(function (memo, num) {
      return memo / parseFloat(num);
    }, arguments[0] * arguments[0]);
  }
}, {
  id: 'EncodeBase64',
  type: 'formula',
  minparams: 1,
  maxparams: 1,
  callback: btoa
}, {
  id: 'Find',
  type: 'formula',
  minparams: 2,
  maxparams: 2,
  sticky: ['Text', 'Regex'],
  callback: function callback(str, regex) {
    var r = new RegExp(regex);
    return str.match(r);
  }
}, {
  id: 'Floor',
  type: 'formula',
  minparams: 1,
  maxparams: 1,
  callback: Math.floor
}, {
  id: 'If',
  type: 'formula',
  minparams: 3,
  maxparams: 3,
  sticky: ['Expression', 'Then', 'Else'],
  callback: function callback(expr, _then, _else) {
    return !expr || expr === 'false' ? _else : _then;
  }
}, {
  id: 'Join',
  type: 'formula',
  minparams: 3,
  maxparams: 999,
  sticky: ['Separator'],
  callback: function callback() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return args.slice(1).join(arguments[0]);
  }
}, {
  id: 'Length',
  type: 'formula',
  minparams: 1,
  maxparams: 1,
  callback: function callback(str) {
    return str.length;
  }
}, {
  id: 'Multiply',
  type: 'formula',
  minparams: 2,
  maxparams: 999,
  callback: function callback() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return args.reduce(function (memo, num) {
      return memo * parseFloat(num);
    }, 1);
  }
}, {
  id: 'Or',
  type: 'formula',
  minparams: 2,
  maxparams: 999,
  callback: function callback() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    return args.reduce(function (memo, num) {
      return memo || !!num;
    }, false);
  }
}, {
  id: 'Power',
  type: 'formula',
  minparams: 2,
  maxparams: 2,
  sticky: ['Base', 'Exponent'],
  callback: Math.pow
}, {
  id: 'Replace',
  type: 'formula',
  minparams: 3,
  maxparams: 3,
  sticky: ['Text', 'Find', 'Replace'],
  callback: function callback(str, find, replace) {
    var r = new RegExp(find, 'g');
    return str.replace(r, replace);
  }
}, {
  id: 'Split',
  type: 'formula',
  minparams: 2,
  maxparams: 2,
  sticky: ['Text', 'Separator'],
  callback: function callback(str, sep) {
    return str.split(sep);
  }
}, {
  id: 'Substract',
  type: 'formula',
  minparams: 2,
  maxparams: 9999,
  callback: function callback() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    return args.reduce(function (memo, num) {
      return memo - parseFloat(num);
    }, 2 * arguments[0]);
  }
}, {
  id: 'Substring',
  type: 'formula',
  minparams: 3,
  maxparams: 3,
  sticky: ['Text', 'Start', 'End'],
  callback: function callback(str, start, end) {
    start = parseInt(start) || 0;
    end = parseInt(end) || str.length;
    return str.substring(start, end);
  }
}, {
  id: 'Value',
  type: 'text'
}];

var getDefinition = function getDefinition(id) {
  return definitions.find(function (def) {
    return def.id === id;
  });
};

export default {
  getDefinition: getDefinition
};